import {
  collection,
  deleteDoc,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../../firebase/firebase-config';
import { COLLECTIONS } from '../constants';
import { NOTIFICATIONS_PAGE_SIZE } from './notificationConstants';

function notificationsCollection(userId) {
  return collection(db, COLLECTIONS.USERS, userId, COLLECTIONS.NOTIFICATIONS);
}

export function mapNotificationDoc(docSnap) {
  const data = docSnap.data();
  return {
    id: docSnap.id,
    tenantId: data.tenantId || null,
    type: data.type || null,
    moduleId: data.moduleId || null,
    title: data.title || '',
    body: data.body || '',
    link: data.link || '',
    targetId: data.targetId || null,
    createdAt: data.createdAt?.toDate?.() ?? null,
    readAt: data.readAt?.toDate?.() ?? null,
  };
}

export function subscribeNotifications(userId, tenantId, onData, onError) {
  if (!userId || !tenantId) {
    return () => {};
  }

  const listQuery = query(
    notificationsCollection(userId),
    where('tenantId', '==', tenantId),
    orderBy('createdAt', 'desc'),
    limit(NOTIFICATIONS_PAGE_SIZE),
  );

  return onSnapshot(
    listQuery,
    (snapshot) => {
      onData(snapshot.docs.map(mapNotificationDoc));
    },
    onError,
  );
}

export async function markNotificationAsRead(userId, notificationId) {
  if (!userId || !notificationId) return;

  await updateDoc(
    doc(db, COLLECTIONS.USERS, userId, COLLECTIONS.NOTIFICATIONS, notificationId),
    { readAt: serverTimestamp() },
  );
}

export async function markAllNotificationsAsRead(userId, notifications) {
  if (!userId || !notifications?.length) return;

  const unread = notifications.filter((item) => !item.readAt);
  await Promise.all(unread.map((item) => markNotificationAsRead(userId, item.id)));
}

export async function deleteNotification(userId, notificationId) {
  if (!userId || !notificationId) return;

  await deleteDoc(
    doc(db, COLLECTIONS.USERS, userId, COLLECTIONS.NOTIFICATIONS, notificationId),
  );
}
